import { createContext, useContext } from 'react';

// Tema de marca de Compras Sanitarias. Los colores se usan inline en estilos
// (theme.primary / theme.primaryDark), NO como clases de Tailwind, para que no
// se purguen en el build de producción.
export const defaultTheme = {
  primary: '#0099FF',
  primaryDark: '#007ACC',
};

// El valor por defecto del contexto ya incluye el tema, así que useTheme()
// funciona con o sin ThemeProvider (cae al defaultTheme si no hay Provider).
const ThemeContext = createContext({ theme: defaultTheme });

// Provider opcional: permite sobreescribir el tema (p. ej. color por cliente)
// envolviendo la app o una parte de ella.
export const ThemeProvider = ({ theme = defaultTheme, children }) => (
  <ThemeContext.Provider value={{ theme }}>
    {children}
  </ThemeContext.Provider>
);

export const useTheme = () => useContext(ThemeContext);

export default ThemeContext;
